/** Custom event name used to open the drawer from anywhere in the app. */
export const ONBOARDING_DRAWER_OPEN_EVENT = "onboarding-drawer-open";

/** Custom event name used to close the drawer (e.g. after in-app navigation). */
export const ONBOARDING_DRAWER_CLOSE_EVENT = "onboarding-drawer-close";
